import Effects from 'Effects';
import Tone from 'tone';
import {AbstractParameter} from 'parameters/AbstractParameter.js';
import {AbstractAudioParamParameter,
        AudioParamValueParameter} from 'parameters/AbstractAudioParamParameter.js';
import {decibelsToLinear, linearToDecibels} from 'utils/db.js';
import DelayEffect from './Delay.js';

const SIZE = 65536;

class StereoDelay extends Effects.Effect {

    constructor(sequencerEngine) {
        super('Stereo Delay', () => new Tone.Gain(1), sequencerEngine); 

        this.initComponents();

        this.isSynced = true;
        this.wetParameter = new AbstractParameter(
            'Wet', this, (obj, wet) => {
                this.leftDelay.wetParameter.set(wet);
                this.rightDelay.wetParameter.set(wet);
            },
            {
                min: 0,
                max: 1,
                unit: '',
                defaultValue: 0,
                constantAutomationRate: true
            });
        this.registerParameter(this.wetParameter);

        this.feedbackParameter = new AbstractParameter(
            'Feedback', this, (obj, feedback) => {
                this.leftDelay.feedbackParameter.set(feedback);
                this.rightDelay.feedbackParameter.set(feedback);
            },
            {
                min: 0,
                max: 1,
                unit: '',
                defaultValue: 0,
                constantAutomationRate: true
            });
        this.registerParameter(this.feedbackParameter);
        this.updateInitialValues();
    }

    connect(node) {
        this.outputNode.connect(node);
    }

    disconnect(node) {
        this.outputNode.disconnect(node);
    }

    initComponents() {
        this.leftDelay = new DelayEffect(this.sequencerEngine);
        this.rightDelay = new DelayEffect(this.sequencerEngine);

        this.effectNode.connect(this.leftDelay.effectNode);
        this.effectNode.connect(this.rightDelay.effectNode);

        this.merger = new Tone.Merge();
        this.leftDelay.connect(this.merger.left);
        this.rightDelay.connect(this.merger.right);
        this.outputNode = new Tone.Gain(1);
        this.merger.connect(this.outputNode);
    }

    getJson() {
        let json = {
            ... super.getJson(),
            leftDelay: this.leftDelay.getJson(),
            rightDelay: this.rightDelay.getJson(),
            wet: this.wetParameter.get(),
            feedback: this.feedbackParameter.get(),
            isSynced: this.isSynced,
        };

        json = this.saveParameterToJson(json, 'wetParameter', this.wetParameter);
        json = this.saveParameterToJson(json, 'feedbackParameter', this.feedbackParameter);
        return json;
    }

    fromJson(json, isCopy) {
        super.fromJson(json, isCopy);
        this.isSynced = json.isSynced;
        this.wetParameter.set(json.wet);
        this.feedbackParameter.set(json.feedback);
        this.leftDelay.fromJson(json.leftDelay);
        this.rightDelay.fromJson(json.rightDelay);
        this.loadParameterFromJson(json, 'feedbackParameter', this.feedbackParameter, isCopy);
        this.loadParameterFromJson(json, 'wetParameter', this.wetParameter, isCopy);
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        var copy = new StereoDelay(sequencerEngine);
        copy.fromJson(this.getJson(), ignoreId);
        return copy;
    }
}

export default StereoDelay;
